import styled from 'styled-components';

const StyledInvoiceAttachmentPreview = styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.neutral_1};
`;

const StyledInvoiceAttachmentPreviewFile = styled.div`
  max-height: ${props => props.fullscreen === 'true' ? 'unset' : '600px'};
  overflow: auto;
  > * {
    margin: auto;
    max-width: min(1150px, 100%);
    width: 100%;

    &:not(.react-pdf__Document) {
      display: flex;
    }
  }
  .react-pdf__Page {
    > * {
      height: auto !important;
      width: 100% !important;
    }
  }
`;

const StyledInvoiceAttachmentPreviewFullscreenButtonContainer = styled.div`
  position: ${props => props.fullscreen === 'true' ? 'fixed' : 'absolute'};
  top: 8px;
  right: 8px;
  z-index: 10;
`;

export {
  StyledInvoiceAttachmentPreview,
  StyledInvoiceAttachmentPreviewFile,
  StyledInvoiceAttachmentPreviewFullscreenButtonContainer,
};
